import { Controller } from "stimulus"

export default class extends Controller {
    isEditable = false;

    initialize() {
        var element = document.getElementById("contents")
        var texteditor = document.querySelector('trix-editor')
        texteditor.value = element.innerHTML;
        element.innerHTML = texteditor.value;
    }

    edit() {
        var element = document.getElementById("contents")
        var editor = document.getElementById("editor")
        var texteditor = document.querySelector('trix-editor')
        var editButton = document.getElementById("edit");
        var saveButton = document.getElementById("save");
        texteditor.value = element.innerHTML;
        element.classList.toggle("hidden")
        editor.classList.toggle("hidden")
        editButton.classList.toggle("hidden")
        saveButton.classList.toggle("hidden")
        this.isEditable = true;
    }

    save() {
        var element = document.getElementById("contents")
        var editor = document.getElementById("editor")
        var texteditor = document.querySelector('trix-editor')
        var editButton = document.getElementById("edit");
        var saveButton = document.getElementById("save");
        element.innerHTML = texteditor.value;
        element.classList.toggle("hidden")
        editor.classList.toggle("hidden")
        editButton.classList.toggle("hidden")
        saveButton.classList.toggle("hidden")
        this.isEditable = false;
    }

    copy() {
        if (this.isEditable) {
            var copyElement = document.querySelector('trix-editor')
        } else {
            var copyElement = document.getElementById("contents")
        }
        copyElement.focus()
        this.selectText(copyElement)
        document.execCommand("copy");
        if (window.getSelection) {
            window.getSelection().removeAllRanges();
        } else if (document.selection) {
            document.selection.empty();
        }
    }

    selectText(node) {
        if (document.body.createTextRange) {
            const range = document.body.createTextRange();
            range.moveToElementText(node);
            range.select();
        } else if (window.getSelection) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(node);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
}